import { createUserManager } from 'redux-oidc';
import moment from 'moment';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { b2cSettings } from './b2cSettings';
import { decodeAccessToken } from './decodeAccessToken';
import { ensureTrailingForwardslash } from 'lib/utils/text';

const valueOrDefault = (value: string | null | undefined, defaultValue: string) => (value && value != 'null' ? value : defaultValue);

const tenantName = valueOrDefault(b2cSettings.tenantName, 'not_used');
const hostName = valueOrDefault(b2cSettings.hostName, 'not_used');
const policySignUpSignIn = valueOrDefault(b2cSettings.policySignUpSignIn, 'not_used');
const redirectUrlSetting = valueOrDefault(b2cSettings.redirectUrl, 'dynamic');
const redirectUrl = ensureTrailingForwardslash(redirectUrlSetting == 'dynamic' ? window.location.origin : redirectUrlSetting);
const testAuthBaseUrl = valueOrDefault(b2cSettings.testAuthBaseUrl, '');
const clientId = valueOrDefault(!testAuthBaseUrl ? b2cSettings.clientId : '', 'kolmeo-test-auth');

const settings: UserManagerSettings = {
  authority: valueOrDefault(testAuthBaseUrl, `https://${hostName}/${tenantName}/${policySignUpSignIn}/v2.0/`),
  client_id: clientId,
  redirect_uri: `${redirectUrl}auth-callback/`,
  post_logout_redirect_uri: redirectUrl,
  automaticSilentRenew: false,
  silent_redirect_uri: `${redirectUrl}silent-token-renewal-callback/`,
  response_type: 'id_token',
  scope: 'openid',
  prompt: 'login',
  response_mode: 'fragment',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  loadUserInfo: false
};

const userManager = createUserManager(settings);

let timeoutHandler: number | undefined;

export const trackTokenExpiration = (jwt: string) => {
  const { setTimeout } = window;
  const token = decodeAccessToken(jwt);
  const expDate = new Date(token.exp * 1000);
  const nowDate = new Date(Date.now());

  //one minute before token expiry
  const renewalTimeInMilliseconds = moment(expDate).diff(nowDate) - 60000;

  const signinSilent = () => {
    userManager.signinSilent();
  };

  //Clear previous timeout
  if (timeoutHandler !== undefined) clearTimeout(timeoutHandler);

  //Setup a one time silent token renewal. Because when user is loaded/reloaded it will be setup again.
  timeoutHandler = setTimeout(signinSilent, renewalTimeInMilliseconds);
};

userManager.events.addUserLoaded(user => {
  trackTokenExpiration(user.id_token);
});

userManager.events.addSilentRenewError(error => {
  // eslint-disable-next-line no-console
  console.error(`Failed to silent renew token: ${error.message}`);
  userManager.signinRedirect();
});

export default userManager;
